
const temp = (skills, available) => skills.map(item => `
<div class="skills-item d-flex align-items-center js-skill-item" data-current="${item.current > 0 ? item.current : 0}" data-name="${item.name}">
    <div class="skills-item__label">${item.display_name}</div>
    <div class="skills-item__power d-flex">
        <div class="skills-power skills-power__default" style="width: ${item.current > 0 ? item.current : 0}%;"></div>
        <div class="skills-power skills-power__attached js-skil-upgrade" style="width: 0%;"></div>
        <div class="skills-power skills-power__remainder" style="width: 0%;"></div>
    </div>
    <div class="skills-item__actions d-flex align-items-center justify-content-center">
          <button type="button" class="skills-item__actions-minus d-flex align-items-center justify-content-center js-skill-down" disabled><i class="icon-minus"></i></button>
          <button type="button" class="skills-item__actions-plus d-flex align-items-center justify-content-center js-skill-up" ${available >= item.points[item.current > 0 ? item.current : 0] ? '' : 'disabled'} ><i class="icon-plus"></i></button>
    </div>
    <div class="skills-item__score">
      <span class="current">${item.current > 0 ? item.current : 0}</span> (*<span class="required-point">${item.points[item.current > 0 ? item.current : 0]}</span>)
    </div>
</div>
`).join('');

export default ({ skills, available, skillVisible }) => {
  const html = `
  <div class="stat-detail__box">
      <div class="stat-detail__head d-flex">
          <div class="stat-detail__head-title stat-detail__head-title--action active mr-4 js-tab-toggle" target="#tab-skills">Skills</div>
          <div class="stat-detail__head-title stat-detail__head-title--action js-tab-toggle ${skillVisible ? 'd-block' : 'd-none'}" target="#tab-items">Items</div>
      </div>
      <div id="tab-skills" class="js-tabs stat-detail__content js-content">
          <div class="js-skills">
            ${temp(skills, available)}
          </div>

          <div class="js-control-skills skills-actions ${skillVisible ? 'd-flex flex-column flex-lg-row' : 'd-none'} justify-content-between mt-3 mb-3">
              <p>* Required tp amount.</p>
              <div class="d-flex">
              <button class="js-owner-only js-remove-skills default-button w-100 mr-3"
                      data-generation="{{ info.generation }}"
                      data-id="{{ info.entity_id }}"
                      data-token-id="{{ info.entity_id }}" type="submit">
                  <span>Reset Skills</span>
              </button>
              <button class="default-button js-set-skills"><span>Save</span></button>
              </div>
          </div>
      </div>
      <div id="tab-items" class="js-tabs stat-detail__content d-none js-content">
        <div class="col-12 mb-4 js-detail-items js-owner-only check-owner" data-owner="{{ info.owner }}">
            <div class="js-content">

            </div>
        </div>
      </div>
  </div>
  `;

  // <button class="btn btn-default js-reset-skills" style="visibility: hidden;">Rest</button>

  return html;
};
